import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    id: "related-events",
    class: "mb-20 block w-full overflow-hidden",
    "data-post-carousel-block": ""
};
import SectionHeader from '@molecules/SectionHeader.vue';
import PostCarousel from '@molecules/PostCarousel.vue';
import { computed, ref } from 'vue';
import { generateUniqueId } from '@helpers/text';
export default /*@__PURE__*/ _defineComponent({
    __name: 'RelatedPosts',
    props: {
        posts: {
            type: Object,
            required: true,
        },
        button: {
            type: Object,
            required: false,
            default: () => {
                return null;
            },
        },
        postType: {
            type: String,
            required: true,
        },
    },
    setup(__props) {
        const uniqueIdentifier = ref(generateUniqueId());
        const carouselTitle = computed(() => {
            return `related-${props.postType}-${uniqueIdentifier.value}`;
        });
        const title = computed(() => {
            if (props.postType === 'event') {
                return 'Related Events';
            }
            if (isReadWatch.value) {
                return 'Other Stories';
            }
            return 'Read & Watch';
        });
        const subtitle = computed(() => {
            if (props.postType === 'read_watch') {
                return 'Discover more video interviews, quick-reads, activity sheets and in-depth articles.';
            }
            return '';
        });
        const isReadWatch = computed(() => {
            return window.location.href.includes('read-and-watch');
        });
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createVNode(SectionHeader, {
                    button: __props.button,
                    carouselTitle: carouselTitle.value,
                    postType: __props.postType,
                    subtitle: subtitle.value,
                    title: title.value,
                    numberOfPosts: Object.keys(__props.posts).length
                }, null, 8, ["button", "carouselTitle", "postType", "subtitle", "title", "numberOfPosts"]),
                (__props.posts)
                    ? (_openBlock(), _createBlock(PostCarousel, {
                        key: 0,
                        carouselTitle: carouselTitle.value,
                        posts: __props.posts
                    }, null, 8, ["carouselTitle", "posts"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
